'use client';

import Script from 'next/script';

interface GoogleAdsTrackingProps {
  conversionId: string;
}

export function GoogleAdsTracking({ conversionId }: GoogleAdsTrackingProps) {
  return (
    <>
      {/* Google Ads Global Site Tag */}
      <Script
        strategy="afterInteractive"
        src={`https://www.googletagmanager.com/gtag/js?id=${conversionId}`}
      />
      <Script
        id="google-ads-init"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${conversionId}');
          `,
        }}
      />
    </>
  );
}

// Helper function to track conversion events
export function trackConversion(conversionLabel: string, value: number = 1.0) {
  if (typeof window !== 'undefined' && (window as any).gtag) {
    (window as any).gtag('event', 'conversion', {
      'send_to': conversionLabel,
      'value': value,
      'currency': 'CAD',
      'transaction_id': `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`
    });
  } else {
  }
}
